import React from "react";
import "./HomePage.css";


const Legal = () => {
  return (
    <div className="legal">
      <h4>Legal Information</h4>
      <p>
        Give Stream operates in compliance with all applicable laws and
        regulations. This section provides information about our legal
        responsibilities and practices.
      </p>

      <h2>1. Compliance with Laws</h2>
      <p>
        We comply with all applicable local, state, national, and international
        laws and regulations in our operations and practices.
      </p>

      <h2>2. Intellectual Property Rights</h2>
      <p>
        All intellectual property rights in the content and design of Give
        Stream are owned by or licensed to us. You may not use any of our
        intellectual property without our prior written consent.
      </p>

      <h2>3. Dispute Resolution</h2>
      <p>
        Any disputes arising out of or in connection with these terms or your
        use of Give Stream shall be resolved through binding arbitration in
        accordance with the rules of [Arbitration Organization].
      </p>

      <h2>4. Liability Disclaimer</h2>
      <p>
        We are not liable for any damages or losses arising from your use of
        Give Stream or inability to use the platform, except to the extent
        required by law.
      </p>

      <h2>5. Indemnification</h2>
      <p>
        You agree to indemnify and hold us harmless from any claims, damages, or
        expenses arising out of your use of Give Stream or violation of these
        terms.
      </p>

      <h2>6. Severability</h2>
      <p>
        If any provision of these terms is found to be invalid or unenforceable,
        the remaining provisions shall remain in full force and effect.
      </p>

      <h2>7. Contact Information</h2>
      <p>
        If you have any legal inquiries, please contact us at [legaldesk@givestream.com].
      </p>
    </div>
  );
};

export default Legal;
